const styles = (theme) => ({
  categoryName: {
    fontFamily: "Roboto-Bold",
    fontSize: 18,
    textAlign: 'center',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  }
});

export default styles;